import type { Components, Theme } from "@mui/material/styles";

export const MuiCardContent: Components<Theme>["MuiCardContent"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(3),
      "& .MuiFormControl-root": {
        margin: theme.spacing(1.5, 0),
        "&:first-of-type": {
          marginTop: 0,
        },
        "&:last-of-type": {
          marginBottom: 0,
        },
      },
    }),
  },
};
